<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Veterinário*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="filter.veterinario"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Realizada</label>
                                    <Select2
                                        placeholder="Selecionar"
                                        v-model="filter.realizado"
                                        :options="consultas"
                                        opt-id="id"
                                        opt-text="text"
                                    ></Select2>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Nova Consulta
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">{{ item.nome }}</td>
                                    <td
                                        :data-label="headers[2].name"
                                    >{{ item.data | formatDate('DD/MM/YYYY HH:mm:ss' ) }}</td>
                                    <td :data-label="headers[3].name">{{ item.veterinario }}</td>
                                    <td
                                        :data-label="headers[4].name"
                                    >R$ {{ item.preco | formatBRL }}</td>
                                    <td
                                        :data-label="headers[5].name"
                                        v-html="$options.filters.boolSimNao(item.realizado)"
                                    ></td>

                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="far fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../../facade/facade";
import Select2 from "../../../components/Input/Select2";

const facade = new Facade();

export default {
    components: { Select2 },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Consulta", key: "nome" },
                { name: "Data", key: "data" },
                { name: "Veterinário", key: "veterinario" },
                { name: "Preço", key: "preco" },
                { name: "Realizada", key: "realizado" }
            ],
            filter: {
                realizado: null,
                veterinario: ""
            },
            list: {},
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            consultas: [
                { id: "true", text: "Sim" },
                { id: "false", text: "Não" },
                { id: "null", text: "Todas" }
            ]
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        back() {
            this.$router.push({
                name: "list-pet",
                params: {
                    idCliente: this.$route.params.idCliente
                }
            });
        },
        create() {
            this.$router.push({ name: "new-consultation-pet" });
        },
        edit(id) {
            this.$router.push({
                name: "edit-consultation-pet",
                params: {
                    idCliente: this.$route.params.idCliente,
                    id: this.$route.params.id,
                    idConsultation: id
                }
            });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deleteConsultation(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar a Consultas."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },
        clean() {
            this.filter = {
                veterinario: null,
                realizado: null
            };
        },
        fetchData(page) {
            let vm = this;
            vm.page = page;

            this.$loading.show(true);
            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order,
                    id_pet: this.$route.params.id,
                    veterinario: this.filter.veterinario,
                    realizado: this.filter.realizado
                }
            };

            let ret = facade.listConsultation(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as consultas."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?eceb5cc6